import { Box } from '@mantine/core';
import { ConfigFieldValue } from '@/types/automationFields.ts';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import useRetrieveConfigFieldSensitiveValue from '@/hooks/api/integrations/useRetrieveConfigFieldSensitiveValue.ts';
import { useEffect, useState } from 'react';
import { reportException } from '@/services/sentry.ts';
import StyledPasswordInput from '@/components/StyledInputFields/StyledPasswordInput.tsx';
import CustomLoadingOverlay from '@/components/CustomLoadingOverlay.tsx';
import useFieldConfigError from '@/hooks/useFieldConfigError.ts';
import { IntegrationWebhookConfigField } from '@/types/integrations.ts';

type props = {
  stepId: string;
  field: IntegrationWebhookConfigField;
  fieldValue: any;
  fieldValueConfig: ConfigFieldValue;
};

const WebhookField = ({ stepId, field, fieldValue, fieldValueConfig }: props) => {
  const error = useFieldConfigError(stepId, fieldValueConfig);

  const [getApiKey, setGetApiKey] = useState<boolean>(false);

  const { data: unencryptedApiKey, isLoading } = useRetrieveConfigFieldSensitiveValue(
    stepId,
    field.id,
    getApiKey,
  );

  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    try {
      const url = fieldValue['url'];
      setUrl(url);
    } catch (e) {
      reportException(e);
      setUrl('');
    }
  }, [fieldValue]);

  const apiKey =
    unencryptedApiKey?.value && 'api_key' in unencryptedApiKey.value
      ? unencryptedApiKey.value.api_key
      : undefined;

  return (
    <>
      <Box pos="relative">
        <StyledTextInput
          label={'Webhook URL'}
          value={url}
          // description={'Webhook URL'}
          // placeholder={field.placeholder}
          // onChange={(event) => onChange(event.currentTarget.value)}
          // required={true}
          // maxLength={field.max_length}
          error={error?.message}
          readOnly={true}
          // rightSection={
          //   <CopyButton value={url}>
          //     {({ copied, copy }) => (
          //       <Button onClick={copy}>{copied ? 'Copied url' : 'Copy url'}</Button>
          //     )}
          //   </CopyButton>
          // }
        />
      </Box>
      <Box pos="relative">
        <CustomLoadingOverlay visible={isLoading} />

        <StyledPasswordInput
          label="Webhook Bearer token"
          defaultValue="secret"
          value={apiKey}
          visible={getApiKey}
          onVisibilityChange={() => setGetApiKey(!getApiKey)}
          readOnly={true}
          disabled={fieldValueConfig.is_disabled}
        />
      </Box>
    </>
  );
};

export default WebhookField;
